import { Api as api } from "../api";
const prefix = '/master-data'
// const prefix = ''
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    customerServiceV1ListCustomers: build.query<
      CustomerServiceV1ListCustomersApiResponse,
      CustomerServiceV1ListCustomersApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
          search: queryArg.search,
          status: queryArg.status,
          sort_by: queryArg.sortBy,
          order: queryArg.order,
        },
      }),
      providesTags: [{ type: "Customer", id: "LIST" }],
    }),
    customerServiceV1BulkDeleteCustomer: build.mutation<
      CustomerServiceV1BulkDeleteCustomerApiResponse,
      CustomerServiceV1BulkDeleteCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers`,
        method: "DELETE",
        params: {
          ids: queryArg.ids,
        },
      }),
      invalidatesTags: [{ type: "Customer", id: "LIST" }],
    }),
    customerServiceV1CreateCustomer: build.mutation<
      CustomerServiceV1CreateCustomerApiResponse,
      CustomerServiceV1CreateCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers`,
        method: "POST",
        body: queryArg.customerV1CreateCustomerReq,
      }),
      invalidatesTags: [{ type: "Customer", id: "LIST" }],
    }),
    customerServiceV1CreateCustomerDraft: build.mutation<
      CustomerServiceV1CreateCustomerDraftApiResponse,
      CustomerServiceV1CreateCustomerDraftApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/draft`,
        method: "POST",
        body: queryArg.customerV1CreateCustomerDraftReq,
      }),
      invalidatesTags: [{ type: "Customer", id: "LIST" }],
    }),
    customerServiceV1ExportCustomers: build.mutation<
      CustomerServiceV1ExportCustomersApiResponse,
      CustomerServiceV1ExportCustomersApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/export`,
        method: "POST",
        body: queryArg.customerV1ExportCustomersReq,
        responseHandler: (response) =>
          response.ok ? response.blob() : response.json(),
      }),
    }),
    customerServiceV1ImportCustomers: build.mutation<
      CustomerServiceV1ImportCustomersApiResponse,
      CustomerServiceV1ImportCustomersApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/import`,
        method: "POST",
        body: queryArg.apiHttpBody,
      }),
    }),
    customerServiceV1BulkUpdateCustomerStatus: build.mutation<
      CustomerServiceV1BulkUpdateCustomerStatusApiResponse,
      CustomerServiceV1BulkUpdateCustomerStatusApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/status`,
        method: "PATCH",
        body: queryArg.customerV1BulkUpdateCustomerStatusReq,
      }),
      invalidatesTags: [{ type: "Customer", id: "LIST" }],
    }),
    customerServiceV1UploadCustomerLogo: build.mutation<
      CustomerServiceV1UploadCustomerLogoApiResponse,
      CustomerServiceV1UploadCustomerLogoApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/upload-logo`,
        method: "POST",
        body: queryArg.customerV1UploadCustomerLogoReq,
      }),
    }),
    customerServiceV1CreateCustomerAddress: build.mutation<
      CustomerServiceV1CreateCustomerAddressApiResponse,
      CustomerServiceV1CreateCustomerAddressApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/${queryArg.customerId}/addresses`,
        method: "POST",
        body: queryArg.customerServiceV1CreateCustomerAddressBody,
      }),
    }),
    customerServiceV1DeleteCustomerAddress: build.mutation<
      CustomerServiceV1DeleteCustomerAddressApiResponse,
      CustomerServiceV1DeleteCustomerAddressApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/${queryArg.customerId}/addresses/${queryArg.addressId}`,
        method: "DELETE",
      }),
    }),
    customerServiceV1UpdateCustomerAddress: build.mutation<
      CustomerServiceV1UpdateCustomerAddressApiResponse,
      CustomerServiceV1UpdateCustomerAddressApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/${queryArg.customerId}/addresses/${queryArg.addressId}`,
        method: "PATCH",
        body: queryArg.customerServiceV1UpdateCustomerAddressBody,
      }),
    }),
    customerServiceV1CreateCustomerBranch: build.mutation<
      CustomerServiceV1CreateCustomerBranchApiResponse,
      CustomerServiceV1CreateCustomerBranchApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/${queryArg.customerId}/branches`,
        method: "POST",
        body: queryArg.customerServiceV1CreateCustomerBranchBody,
      }),
    }),
    customerServiceV1DeleteCustomerBranch: build.mutation<
      CustomerServiceV1DeleteCustomerBranchApiResponse,
      CustomerServiceV1DeleteCustomerBranchApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/${queryArg.customerId}/branches/${queryArg.branchId}`,
        method: "DELETE",
      }),
    }),
    customerServiceV1UpdateCustomerBranch: build.mutation<
      CustomerServiceV1UpdateCustomerBranchApiResponse,
      CustomerServiceV1UpdateCustomerBranchApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/${queryArg.customerId}/branches/${queryArg.branchId}`,
        method: "PATCH",
        body: queryArg.customerServiceV1UpdateCustomerBranchBody,
      }),
    }),
    customerServiceV1GetCustomerDetail: build.query<
      CustomerServiceV1GetCustomerDetailApiResponse,
      CustomerServiceV1GetCustomerDetailApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/customers/${queryArg.id}` }),
    }),
    customerServiceV1UpdateCustomer: build.mutation<
      CustomerServiceV1UpdateCustomerApiResponse,
      CustomerServiceV1UpdateCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/customers/${queryArg.id}`,
        method: "PUT",
        body: queryArg.customerServiceV1UpdateCustomerBody,
      }),
      invalidatesTags: [{ type: "Customer", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as customerApi };
export type CustomerServiceV1ListCustomersApiResponse =
  /** status 200 A successful response. */ CustomerV1ListCustomersRes;
export type CustomerServiceV1ListCustomersApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  sortBy?: string;
  order?: string;
};
export type CustomerServiceV1BulkDeleteCustomerApiResponse =
  /** status 200 A successful response. */ CustomerV1CustomerMessageRes;
export type CustomerServiceV1BulkDeleteCustomerApiArg = {
  ids: string[];
};
export type CustomerServiceV1CreateCustomerApiResponse =
  /** status 200 A successful response. */ CustomerV1CreateCustomerRes;
export type CustomerServiceV1CreateCustomerApiArg = {
  customerV1CreateCustomerReq: CustomerV1CreateCustomerReq;
};
export type CustomerServiceV1CreateCustomerDraftApiResponse =
  /** status 200 A successful response. */ CustomerV1CreateCustomerDraftRes;
export type CustomerServiceV1CreateCustomerDraftApiArg = {
  customerV1CreateCustomerDraftReq: CustomerV1CreateCustomerDraftReq;
};
export type CustomerServiceV1ExportCustomersApiResponse =
  /** status 200 A successful response. */ Blob;
export type CustomerServiceV1ExportCustomersApiArg = {
  customerV1ExportCustomersReq: CustomerV1ExportCustomersReq;
};
export type CustomerServiceV1ImportCustomersApiResponse =
  /** status 200 A successful response. */ CustomerV1ImportCustomersRes;
export type CustomerServiceV1ImportCustomersApiArg = {
  /** Message that represents an arbitrary HTTP body. It should only be used for
    payload formats that can't be represented as JSON, such as raw binary or
    an HTML page.
    
    
    This message can be used both in streaming and non-streaming API methods in
    the request as well as the response.
    
    It can be used as a top-level request field, which is convenient if one
    wants to extract parameters from either the URL or HTTP template into the
    request fields and also want access to the raw HTTP body.
    
    Example:
    
        message GetResourceRequest {
          // A unique request id.
          string request_id = 1;
    
          // The raw HTTP body is bound to this field.
          google.api.HttpBody http_body = 2;
        }
    
        service ResourceService {
          rpc GetResource(GetResourceRequest) returns (google.api.HttpBody);
          rpc UpdateResource(google.api.HttpBody) returns
          (google.protobuf.Empty);
        }
    
    Example with streaming methods:
    
        service CaldavService {
          rpc GetCalendar(stream google.api.HttpBody)
            returns (stream google.api.HttpBody);
          rpc UpdateCalendar(stream google.api.HttpBody)
            returns (stream google.api.HttpBody);
        }
    
    Use of this type only changes how the request and response bodies are
    handled, all other features will continue to work unchanged. */
  apiHttpBody: ApiHttpBody;
};
export type CustomerServiceV1BulkUpdateCustomerStatusApiResponse =
  /** status 200 A successful response. */ CustomerV1CustomerMessageRes;
export type CustomerServiceV1BulkUpdateCustomerStatusApiArg = {
  customerV1BulkUpdateCustomerStatusReq: CustomerV1BulkUpdateCustomerStatusReq;
};
export type CustomerServiceV1UploadCustomerLogoApiResponse =
  /** status 200 A successful response. */ CustomerV1UploadCustomerLogoRes;
export type CustomerServiceV1UploadCustomerLogoApiArg = {
  customerV1UploadCustomerLogoReq: CustomerV1UploadCustomerLogoReq;
};
export type CustomerServiceV1CreateCustomerAddressApiResponse =
  /** status 200 A successful response. */ CustomerV1CustomerMessageRes;
export type CustomerServiceV1CreateCustomerAddressApiArg = {
  customerId: string;
  customerServiceV1CreateCustomerAddressBody: CustomerServiceV1CreateCustomerAddressBody;
};
export type CustomerServiceV1DeleteCustomerAddressApiResponse =
  /** status 200 A successful response. */ CustomerV1CustomerMessageRes;
export type CustomerServiceV1DeleteCustomerAddressApiArg = {
  customerId: string;
  addressId: string;
};
export type CustomerServiceV1UpdateCustomerAddressApiResponse =
  /** status 200 A successful response. */ CustomerV1CustomerMessageRes;
export type CustomerServiceV1UpdateCustomerAddressApiArg = {
  customerId: string;
  addressId: string;
  customerServiceV1UpdateCustomerAddressBody: CustomerServiceV1UpdateCustomerAddressBody;
};
export type CustomerServiceV1CreateCustomerBranchApiResponse =
  /** status 200 A successful response. */ CustomerV1CustomerMessageRes;
export type CustomerServiceV1CreateCustomerBranchApiArg = {
  customerId: string;
  customerServiceV1CreateCustomerBranchBody: CustomerServiceV1CreateCustomerBranchBody;
};
export type CustomerServiceV1DeleteCustomerBranchApiResponse =
  /** status 200 A successful response. */ CustomerV1CustomerMessageRes;
export type CustomerServiceV1DeleteCustomerBranchApiArg = {
  customerId: string;
  branchId: string;
};
export type CustomerServiceV1UpdateCustomerBranchApiResponse =
  /** status 200 A successful response. */ CustomerV1CustomerMessageRes;
export type CustomerServiceV1UpdateCustomerBranchApiArg = {
  customerId: string;
  branchId: string;
  customerServiceV1UpdateCustomerBranchBody: CustomerServiceV1UpdateCustomerBranchBody;
};
export type CustomerServiceV1GetCustomerDetailApiResponse =
  /** status 200 A successful response. */ CustomerV1GetCustomerDetailRes;
export type CustomerServiceV1GetCustomerDetailApiArg = {
  id: string;
};
export type CustomerServiceV1UpdateCustomerApiResponse =
  /** status 200 A successful response. */ CustomerV1CustomerMessageRes;
export type CustomerServiceV1UpdateCustomerApiArg = {
  id: string;
  customerServiceV1UpdateCustomerBody: CustomerServiceV1UpdateCustomerBody;
};
export type CustomerV1CustomerActor = {
  id?: string;
  name?: string;
  timestamp?: string;
};
export type CustomerV1CustomerListItem = {
  id?: string;
  customer_name?: string;
  customer_code?: string;
  legal_name?: string;
  customer_type?: string;
  status?: string;
  email?: string;
  contact_person_name?: string;
  contact_person_phone_number?: string;
  customer_photo_url?: string;
  created_at?: string;
  updated_at?: string;
  created_by?: CustomerV1CustomerActor | string;
  updated_by?: CustomerV1CustomerActor | string;
};
export type CustomerV1CustomerListMeta = {
  current_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
  limit?: number;
  total?: number;
  total_page?: number;
};
export type CustomerV1ListCustomersRes = {
  customer?: CustomerV1CustomerListItem[];
  metadata?: CustomerV1CustomerListMeta;
};
export type ProtobufAny = {
  /** Identifies the type of the serialized Protobuf message with a URI reference
    consisting of a prefix ending in a slash and the fully-qualified type name.
    
    Example: type.googleapis.com/google.protobuf.StringValue
    
    This string must contain at least one `/` character, and the content after
    the last `/` must be the fully-qualified name of the type in canonical
    form, without a leading dot. Do not write a scheme on these URI references
    so that clients do not attempt to contact them.
    
    The prefix is arbitrary and Protobuf implementations are expected to
    simply strip off everything up to and including the last `/` to identify
    the type. `type.googleapis.com/` is a common default prefix that some
    legacy implementations require. This prefix does not indicate the origin of
    the type, and URIs containing it are not expected to respond to any
    requests.
    
    All type URL strings must be legal URI references with the additional
    restriction (for the text format) that the content of the reference
    must consist only of alphanumeric characters, percent-encoded escapes, and
    characters in the following set (not including the outer backticks):
    `/-.~_!$&()*+,;=`. Despite our allowing percent encodings, implementations
    should not unescape them to prevent confusion with existing parsers. For
    example, `type.googleapis.com%2FFoo` should be rejected.
    
    In the original design of `Any`, the possibility of launching a type
    resolution service at these type URLs was considered but Protobuf never
    implemented one and considers contacting these URLs to be problematic and
    a potential security issue. Do not attempt to contact type URLs. */
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type CustomerV1CustomerMessageRes = {
  message?: string;
};
export type CustomerV1CreateCustomerRes = {
  customer_id?: string;
  customer_code?: string;
  message?: string;
};
export type CustomerV1CreateCustomerAddressItem = {
  address_name?: string;
  address_category: string;
  full_address: string;
  city_id: string;
  province_id: string;
  postal_code?: string;
  google_maps_url?: string;
  is_billing_address?: boolean;
};
export type CustomerV1CreateCustomerBranchItem = {
  branch_name: string;
  pic_name: string;
  pic_email: string;
  pic_phone: string;
  addresses?: CustomerV1CreateCustomerAddressItem[];
};
export type CustomerV1CreateCustomerReq = {
  customer_name: string;
  legal_name?: string;
  customer_type: string;
  status?: string;
  email?: string;
  contact_person_name?: string;
  contact_person_phone_number?: string;
  branches?: CustomerV1CreateCustomerBranchItem[];
  customer_photo_url?: string;
};
export type CustomerV1CreateCustomerDraftRes = {
  customer_id?: string;
  message?: string;
};
export type CustomerV1CreateCustomerDraftReq = {
  customer_name?: string;
  legal_name?: string;
  customer_type?: string;
  customer_code?: string;
  customer_photo_url?: string;
  email?: string;
  contact_person_name?: string;
  contact_person_phone_number?: string;
  branches?: CustomerV1CreateCustomerBranchItem[];
};
export type ApiHttpBody = {
  /** The HTTP Content-Type header value specifying the content type of the body. */
  contentType?: string;
  /** The HTTP request/response body as raw binary. */
  data?: string;
  /** Application specific response metadata. Must be set in the first response
    for streaming APIs. */
  extensions?: ProtobufAny[];
};
export type CustomerV1ListCustomersReq = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  sort_by?: string;
  order?: string;
};
export type CustomerV1ExportCustomersReq = {
  format?: string;
  scope?: string;
  ids?: string[];
  filters?: CustomerV1ListCustomersReq;
  sort_by?: string;
  order?: string;
};
export type CustomerV1CustomerImportError = {
  row?: number;
  field?: string;
  message?: string;
};
export type CustomerV1ImportCustomersRes = {
  success?: boolean;
  imported_count?: number;
  message?: string;
  errors?: CustomerV1CustomerImportError[];
};
export type CustomerV1BulkUpdateCustomerStatusReq = {
  ids: string[];
  status: string;
};
export type CustomerV1UploadCustomerLogoRes = {
  file_url?: string;
  file_name?: string;
  message?: string;
};
export type CustomerV1UploadCustomerLogoReq = object;
export type CustomerServiceV1CreateCustomerAddressBody = {
  branch_id: string;
  address_name?: string;
  address_category: string;
  full_address: string;
  city_id: string;
  province_id: string;
  postal_code?: string;
  google_maps_url?: string;
  is_billing_address?: boolean;
};
export type CustomerServiceV1UpdateCustomerAddressBody = {
  branch_id: string;
  address_name?: string;
  address_category: string;
  full_address: string;
  city_id: string;
  province_id: string;
  postal_code?: string;
  google_maps_url?: string;
  is_billing_address?: boolean;
};
export type CustomerServiceV1CreateCustomerBranchBody = {
  branch_name: string;
  pic_name: string;
  pic_email: string;
  pic_phone: string;
};
export type CustomerServiceV1UpdateCustomerBranchBody = {
  branch_name: string;
  pic_name: string;
  pic_email: string;
  pic_phone: string;
};
export type CustomerV1CustomerAddressDetail = {
  id?: string;
  branch_id?: string;
  address_name?: string;
  address_category?: string;
  full_address?: string;
  city_id?: string;
  province_id?: string;
  postal_code?: string;
  google_maps_url?: string;
  is_billing_address?: boolean;
  city_name?: string;
  province_name?: string;
};
export type CustomerV1CustomerBranchDetail = {
  id?: string;
  branch_name?: string;
  pic_name?: string;
  pic_email?: string;
  pic_phone?: string;
  addresses?: CustomerV1CustomerAddressDetail[];
};
export type CustomerV1GetCustomerDetailRes = {
  id?: string;
  customer_name?: string;
  legal_name?: string;
  customer_code?: string;
  customer_type?: string;
  status?: string;
  email?: string;
  contact_person_name?: string;
  contact_person_phone_number?: string;
  customer_photo_url?: string;
  created_at?: string;
  updated_at?: string;
  created_by?: CustomerV1CustomerActor | string;
  updated_by?: CustomerV1CustomerActor | string;
  branches?: CustomerV1CustomerBranchDetail[];
};
export type CustomerServiceV1UpdateCustomerBody = {
  customer_name: string;
  legal_name?: string;
  customer_type: string;
  status: string;
  email?: string;
  contact_person_name?: string;
  contact_person_phone_number?: string;
  customer_photo_url?: string;
};
export const {
  useCustomerServiceV1ListCustomersQuery,
  useCustomerServiceV1BulkDeleteCustomerMutation,
  useCustomerServiceV1CreateCustomerMutation,
  useCustomerServiceV1CreateCustomerDraftMutation,
  useCustomerServiceV1ExportCustomersMutation,
  useCustomerServiceV1ImportCustomersMutation,
  useCustomerServiceV1BulkUpdateCustomerStatusMutation,
  useCustomerServiceV1UploadCustomerLogoMutation,
  useCustomerServiceV1CreateCustomerAddressMutation,
  useCustomerServiceV1DeleteCustomerAddressMutation,
  useCustomerServiceV1UpdateCustomerAddressMutation,
  useCustomerServiceV1CreateCustomerBranchMutation,
  useCustomerServiceV1DeleteCustomerBranchMutation,
  useCustomerServiceV1UpdateCustomerBranchMutation,
  useCustomerServiceV1GetCustomerDetailQuery,
  useCustomerServiceV1UpdateCustomerMutation,
} = injectedRtkApi;
